import React, { Component } from 'react';
import { connect } from 'react-redux';
import Jmoment from 'moment-jalaali';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';

import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import Pagination2 from '../../components/Pagination2';
import ClientAbsentTable from './clientAbsentTable';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';

import * as reserveActions from '../../redux/reservations/actions';
import * as cafeActions from '../../redux/cafes/actions';
import { domManipulator } from '../../utils';
import ENUMS from '../../enums';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class AddOrEditReserveCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      endDate: ' ',
      startDate: ' ',
      selectedCafe: '',
      clientAbsentOrNotFinishedReservesList: [],
      currentPage: 1,
      itemsPerPage: 10,
      excludeReserveIds: [],

      endDateError: '',
      startDateError: '',
      selectedCafeError: ''
    };
  }

  componentDidMount() {
    this.props.getAllCafeNamesForPanel();
  }

  setStartDate = event => {
    const { value } = event.target;
    this.setState({
      startDate: value ? Jmoment(value, 'YYYY/M/D').format('jYYYY/jMM/jDD') : null,
      startDateError: ''
    });
  };

  setEndDate = event => {
    const { value } = event.target;
    this.setState({
      endDate: value ? Jmoment(value, 'YYYY/M/D').format('jYYYY/jMM/jDD') : null,
      endDateError: ''
    });
  };

  setSelectedCafe = selectedCafe => {
    this.setState({ selectedCafe, selectedCafeError: '' });
  };

  fieldsValidations = _ => {
    return new Promise((resolve, reject) => {
      const {
        startDate,
        endDate,
        selectedCafe,
        endDateError,
        startDateError,
        selectedCafeError
      } = this.state;
      let isStartDateValid, isEndDateValid, isSelectedCafeNameValid;

      if (!selectedCafe) {
        isSelectedCafeNameValid = false;
        this.setState({
          selectedCafeError: locales('messages.fieldValueIsRequired', {
            fieldName: locales('fields.cafe.name')
          })
        });
      } else {
        isSelectedCafeNameValid = true;
        this.setState({ selectedCafeError: '' });
      }

      if (!startDate) {
        isStartDateValid = false;
        this.setState({
          startDateError: locales('messages.fieldValueIsRequired', {
            fieldName: locales('titles.fromTime')
          })
        });
      } else {
        isStartDateValid = true;
        this.setState({ startDateError: '' });
      }

      if (!endDate) {
        isEndDateValid = false;
        this.setState({
          endDateError: locales('messages.fieldValueIsRequired', {
            fieldName: locales('labels.to.date')
          })
        });
      } else {
        isEndDateValid = true;
        this.setState({ endDateError: '' });
      }

      const formIsValid = isSelectedCafeNameValid && isEndDateValid && isStartDateValid;
      if (!formIsValid) return resolve(false);
      return resolve(true);
    });
  };

  showCafeReservations = async event => {
    event.preventDefault();

    const formIsValid = await this.fieldsValidations();
    if (!formIsValid) {
      return;
    }

    domManipulator.scrollToTop();
    const { startDate, endDate, selectedCafe } = this.state;
    const query = `filter=(cafeId~eq~${selectedCafe.value})~and~(date~gte~${startDate}~and~date~lte~${endDate})`;

    return this.props.fetchAllClientAbsentOrNotFinishedReserve(query).then(_ => {
      this.setState({
        clientAbsentOrNotFinishedReservesList: this.props.clientAbsentOrNotFinishedReservesList
      });
    });
  };

  submitForm = async () => {
    const formIsValid = await this.fieldsValidations();
    if (!formIsValid) {
      return;
    }

    const { startDate, excludeReserveIds, endDate, selectedCafe } = this.state;

    let checkoutItem = {
      fromDate: startDate,
      toDate: endDate,
      cafeId: selectedCafe.value,
      excludeReserveIds
    };
    this.props.checkoutCafeReserves(checkoutItem).then(_ => {
      const {
        checkoutCafeReservesError,
        checkoutCafeReservesFailed,
        checkoutCafeReservesMessage
      } = this.props;
      if (
        checkoutCafeReservesError == false &&
        checkoutCafeReservesFailed == false &&
        checkoutCafeReservesMessage == ''
      ) {
        AlertAndConfirmation({
          title: locales('titles.insertedSuccessfully'),
          text: '',
          type: 'success'
        });
        this.props.history.push('/reserve/checkout');
      }
    });
  };

  excludeReserveIds = excludeReserveIds => {
    this.setState({ excludeReserveIds });
  };

  handlePageChange = number => {
    console.log('nnnnnnnnnnn', number);
    this.setState(state => {
      state.currentPage = number.currentPage;
      state.clientAbsentOrNotFinishedReservesList = this.props.clientAbsentOrNotFinishedReservesList.slice(
        number,
        number + this.state.itemsPerPage
      );
      return '';
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCafeDiscountRequests(query);
    });
  };

  render() {
    const {
      clientAbsentOrNotFinishedReservesLoading,
      clientAbsentOrNotFinishedReservesFailed,
      clientAbsentOrNotFinishedReservesError,
      clientAbsentOrNotFinishedReservesMessage,

      checkoutCafeReservesLoading,
      checkoutCafeReservesFailed,
      checkoutCafeReservesError,
      checkoutCafeReservesMessage,
      checkoutCafeReservesList,

      cafeNamesError,
      cafeNamesFailed,
      cafeNamesList,
      cafeNamesLoading,
      cafeNamesMessage
    } = this.props;

    const {
      endDate,
      startDate,
      selectedCafe,
      currentPage,
      itemsPerPage,
      clientAbsentOrNotFinishedReservesList,

      endDateError,
      selectedCafeError,
      startDateError
    } = this.state;

    return (
      <section className="p-1 col-12">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-muted py-4">
            <div className="text-right">{locales('titles.reservesCheckout')}</div>
          </h3>
          <div>
            <button onClick={() => this.submitForm()} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <button
              onClick={() => {
                this.props.history.push({
                  pathname: '/reserve/checkout'
                });
              }}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>
        <Spin
          spinning={
            clientAbsentOrNotFinishedReservesLoading || cafeNamesLoading || checkoutCafeReservesLoading
          }
        >
          <article>
            <main className="panel panel-default">
              {clientAbsentOrNotFinishedReservesError || cafeNamesError || checkoutCafeReservesError ? (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              ) : (
                <>
                  {(clientAbsentOrNotFinishedReservesFailed ||
                    cafeNamesFailed ||
                    checkoutCafeReservesFailed) && (
                    <div className="alert alert-danger">
                      {clientAbsentOrNotFinishedReservesMessage ||
                        cafeNamesMessage ||
                        checkoutCafeReservesMessage}
                    </div>
                  )}
                  <div className="panel-heading">
                    <i className="fas fa-list-alt px-1" />
                    {locales('titles.checkedoutReservesList')}
                  </div>
                  <div className="panel-body">
                    <div className="d-flex col-12 justify-content-between align-items-center">
                      <div className="w-100">
                        <div className="w-100 required d-flex">
                          <label className="rsee-form-label">{locales('titles.fromTime')}</label>
                          <DatePicker
                            marge={true}
                            placeholder="تاریخ شروع"
                            name="startDate"
                            id="startDate"
                            className={`${
                              !!startDateError ? 'is-invalid' : ''
                            } text-center form-control ml-4 required`}
                            placeholder={locales('titles.fromTime')}
                            onChange={this.setStartDate}
                            value={startDate}
                          />
                        </div>
                        {!!startDateError && <div className="text-danger text-center">{startDateError}</div>}
                      </div>

                      <div className="w-100">
                        <div className="w-100 required d-flex">
                          <label className="rsee-form-label">{locales('labels.to.date')}</label>
                          <DatePicker
                            marge={true}
                            placeholder="تاریخ شروع"
                            name="endDate"
                            id="endDate"
                            className={`${
                              !!endDateError ? 'is-invalid' : ''
                            } text-center form-control ml-4 required`}
                            placeholder={locales('labels.to.date')}
                            onChange={this.setEndDate}
                            value={endDate}
                          />
                        </div>
                        {!!endDateError && <div className="text-danger text-center">{endDateError}</div>}
                      </div>

                      <div className="w-100">
                        <div className="w-100 required d-flex px-2">
                          <label className="rsee-form-label">{locales('fields.cafe.name')}</label>
                          <Select
                            className={`${
                              !!selectedCafeError ? 'is-invalid' : ''
                            } text-center w-100 required`}
                            value={selectedCafe}
                            options={cafeNamesList.map(cafeName => ({
                              label: cafeName.name,
                              value: cafeName.id
                            }))}
                            placeholder={locales('fields.cafe.name')}
                            isMulti={false}
                            onChange={this.setSelectedCafe}
                          />
                        </div>
                        {!!selectedCafeError && (
                          <div className="text-danger text-center">{selectedCafeError}</div>
                        )}
                      </div>
                      <ShowForPermission
                        permission={ENUMS.PERMISSIONS.values.VIEW_RESERVES_READY_TO_CHECKOUT_LIST}
                      >
                        <button onClick={this.showCafeReservations} className="btn btn-primary w-50">
                          {locales('titles.showCafeReserves')}
                        </button>
                      </ShowForPermission>
                    </div>
                    <ClientAbsentTable
                      excludeReserveIds={this.excludeReserveIds}
                      checkoutList={clientAbsentOrNotFinishedReservesList}
                    />
                    <footer className="col-12 d-flex justify-content-center py-2">
                      <div className="pagination-container">
                        <Pagination2
                          totalRecords={0}
                          pageLimit={itemsPerPage || 0}
                          pageNeighbours={2}
                          onPageChanged={this.handlePageChange}
                          currentPage={this.state.currentPage}
                        />
                      </div>
                    </footer>
                  </div>
                </>
              )}
            </main>
          </article>
        </Spin>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNames: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    clientAbsentOrNotFinishedReservesLoading:
      state.reservationsReducer.clientAbsentOrNotFinishedReservesLoading,
    clientAbsentOrNotFinishedReservesFailed:
      state.reservationsReducer.clientAbsentOrNotFinishedReservesFailed,
    clientAbsentOrNotFinishedReservesError: state.reservationsReducer.clientAbsentOrNotFinishedReservesError,
    clientAbsentOrNotFinishedReservesMessage:
      state.reservationsReducer.clientAbsentOrNotFinishedReservesMessage,
    clientAbsentOrNotFinishedReservesList: state.reservationsReducer.clientAbsentOrNotFinishedReservesList,
    clientAbsentOrNotFinishedReserves: state.reservationsReducer.clientAbsentOrNotFinishedReserves,

    checkoutCafeReservesLoading: state.reservationsReducer.checkoutCafeReservesLoading,
    checkoutCafeReservesFailed: state.reservationsReducer.checkoutCafeReservesFailed,
    checkoutCafeReservesError: state.reservationsReducer.checkoutCafeReservesError,
    checkoutCafeReservesMessage: state.reservationsReducer.checkoutCafeReservesMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel()),
    checkoutCafeReserves: item => dispatch(reserveActions.checkoutCafeReserves(item)),
    fetchAllClientAbsentOrNotFinishedReserve: query =>
      dispatch(reserveActions.fetchAllClientAbsentOrNotFinishedReserve(query))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddOrEditReserveCheckout));
